export const rounds: { [key: string]: string } = {
  F: 'Final',
  SF: 'Semi-Final',
  QF: 'Quarter-Final',
  R16: 'Round of 16',
  R32: 'Round of 32',
  RR: 'Round-Robin',
};



// WEBPACK FOOTER //
// ./src/app/constants/rounds.ts